import * as constants from './constants'
import * as pages from './pages'

const allRoles = constants.roles

export interface RouteData {
    userRoles: readonly Role[]
    page: () => JSX.Element
}

export const routeMap = new Map<string, RouteData>()
    .set('/sign-in', {
        page: pages.SignIn,
        userRoles: [],
    })
    .set('/update-password', {
        page: pages.Home,
        userRoles: allRoles,
    })
    .set('/profile', {
        page: pages.Home,
        userRoles: allRoles,
    })
    .set('/profile-edit', {
        page: pages.EditProfile,
        userRoles: allRoles,
    })
    .set('/not-found', {
        page: pages.Home,
        userRoles: allRoles,
    })
    .set('/forbidden', {
        page: pages.Home,
        userRoles: allRoles,
    })
    .set('/profile', {
        page: pages.Profile,
        userRoles: allRoles,
    })
    .set('/', {
        userRoles: allRoles,
        page: pages.Home,
    })

// @ts-ignore
export const routeArray = [...routeMap].map(([path, r]) => ({ ...r, path }))
